import { IsNotEmpty } from "class-validator";

export default class DeleteCastReq {
  @IsNotEmpty({
    message: "",
  })
  readonly castId: number;

  constructor(arg: any) {
    arg = arg || {};
    this.castId = arg.castId;
  }
}
